interface PdpHeaderTabLabel {
  [key: string]: string;
}

// please preserve the order of this object
const PDP_HEADER_TAB_LABEL: PdpHeaderTabLabel = {
  LISTING: 'listing',
  MESSAGES: 'messages',
  APPLICATIONS: 'applications',
  LEASES: 'leases',
  PAYMENTS: 'payments',
  ANALYTICS: 'analytics',
};

interface TabPaths {
  [key: string]: string;
}

// TODO (ALWAYS): must update path when stand alone apps go live
const TAB_PATHS: TabPaths = {
  listing: '/rental-manager/properties/:propertyId/listing',
  messages: '/rental-manager/inbox/:propertyId?byProperty=true',
  applications: '/rental-manager/applications?propertyId=:propertyId',
  leases: '/rental-manager/leasing/property/:propertyId',
  payments: '/rental-manager/payments/properties/:propertyId',
  analytics: '/rental-manager/properties/:propertyId/analytics',
};

export { PDP_HEADER_TAB_LABEL, TAB_PATHS };
